import { Logger, useIntl } from '@capsicum/common';
import { ModalService } from '@capsicum/common-web';
import { useNCGenerateRecoveryKit } from '@socios-blk/browser';
import { useState } from 'react';

import { NCRegistrationErrorDrawer } from '../ui';

const useRecoveryKit = () => {
	const [{ code, keyId }, setRecoveryKit] = useState({
		code: '',
		keyId: ''
	});

	return {
		code,
		keyId,
		setRecoveryKit
	};
};

const useGenerateRecoveryKit = () => {
	const [loading, setIsGeneratingRecoveryKit] = useState(false);
	const { code, keyId, setRecoveryKit } = useRecoveryKit();
	const { generateRecoveryKit: sdkGenerateRecoveryKit } = useNCGenerateRecoveryKit();

	const handleCaughtError = (error: any) => {
		Logger.error(error as Error);

		openNCRegistrationErrorDrawer();
	};

	/**
	 * Open the error drawer for any issue during the generation process.
	 */
	const openNCRegistrationErrorDrawer = () => {
		setIsGeneratingRecoveryKit(false);

		ModalService.addModal({
			detached: false,
			renderComponent: ({ close }) => (
				<NCRegistrationErrorDrawer closeModal={close} testID="ncOnboarding-registrationError-drawer" />
			)
		});
	};

	const generateRecoveryKit = async () => {
		setIsGeneratingRecoveryKit(true);

		try {
			const recoveryKit = await sdkGenerateRecoveryKit();

			setIsGeneratingRecoveryKit(false);
			setRecoveryKit({
				code: recoveryKit.dfnsRecoveryCode,
				keyId: recoveryKit.dfnsRecoveryKeyId
			});
		} catch (error) {
			handleCaughtError(error);
		}
	};

	return {
		code,
		generateRecoveryKit,
		keyId,
		loading
	};
};

const useRecoveryKitTexts = () => {
	const { $t } = useIntl();

	return {
		alertSubtitle: $t('ncOnboarding.recoveryKit.generateRecoveryKit.alertSubtitle'),
		alertTitle: $t('ncOnboarding.recoveryKit.generateRecoveryKit.alertTitle'),
		buttonContinue: $t('ncOnboarding.recoveryKit.buttonContinue'),
		buttonCopySnack: $t('ncOnboarding.recoveryKit.buttonCopySnack'),
		buttonDownload: $t('ncOnboarding.recoveryKit.buttonDownload'),
		buttonGenerate: $t('ncOnboarding.recoveryKit.generateRecoveryKit.buttonGenerate'),
		checkboxFundsLost: $t('ncOnboarding.recoveryKit.modal.checkboxFundsLost'),
		checkboxSecuredKit: $t('ncOnboarding.recoveryKit.modal.checkboxSecuredKit'),
		checkboxSocios: $t('ncOnboarding.recoveryKit.modal.checkboxSocios'),
		checkboxWillSecureKit: $t('ncOnboarding.recoveryKit.generateRecoveryKit.checkboxWillSecureKit'),
		explanation: $t('ncOnboarding.recoveryKit.generateRecoveryKit.explanation'),
		generatedTitle: $t('ncOnboarding.recoveryKit.generateRecoveryKit.generatedTitle'),
		inputRecoveryCode: $t('ncOnboarding.recoveryKit.form.inputRecoveryCode'),
		inputRecoveryKeyId: $t('ncOnboarding.recoveryKit.form.inputRecoveryKeyId'),
		title: $t('ncOnboarding.recoveryKit.generateRecoveryKit.title')
	};
};

export const useNCGenerateRecoveryKitWeb = () => ({
	intlTexts: useRecoveryKitTexts(),
	...useGenerateRecoveryKit()
});
